import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

export type SsoLinkStatus = 'loading' | 'success' | 'failed';

export type SsoLink = {
    link?: string;
    status?: SsoLinkStatus;
    expirationDate?: number;
};

type GlobalState = {
    ssoLinks: Record<string, SsoLink>;
};

const initialState: GlobalState = {
    ssoLinks: {},
};

type AddSsoLinkPayload = {
    template: string;
    link?: string;
    status?: SsoLinkStatus;
    expirationDate?: number;
};

export const slice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        addSsoLink: (state, action: PayloadAction<AddSsoLinkPayload>) => {
            const {template, link, status, expirationDate} = action.payload;
            return {
                ...state,
                ssoLinks: {
                    ...state.ssoLinks,
                    [template]: {link, status, expirationDate},
                },
            };
        },
    },
});

export const {addSsoLink} = slice.actions;
export default slice.reducer;
